import _ from 'lodash';
import config from 'client/shared/config';

import {
	autorun,
	observable,
	action,
	observe,
	computed,
	runInAction,
	reaction,
	extendObservable,
	toJS
} from 'mobx';

import BaseStore from './base-store';
import apiStore from './api-store';

class StatsStore extends BaseStore {
	userID;

	@observable
	_stats = {};

	@observable
	_dailyStats = null;

	@observable
	isLoadingDaily = false;

	constructor () {
		super();

		reaction(() => apiStore.data.stats, this.onNewData);
	}

	@computed
	get stats () {
		return this._stats;
	}

	set stats (stats) {
		this._stats = stats;
	}

	@computed
	get dailyStats () {
		return this._dailyStats;
	}

	@computed
	get mostListenedToSongTitle () {

		const { mostListenedToSong = {} } = this.stats;
		return mostListenedToSong.title;
	}

	@computed
	get mostHifivedSongTitle () {
		console.log('[this.stats]', this.stats);
		const { mostHifivedSong = {} } = this.stats;
		return mostHifivedSong.title;
	}

	@action
	async fetchStats (user) {
		this.isLoading = true;

		try {

			const { data: { stats } } = await this.ax
				.get(config.routes.profile.replace(/\:id/, user.id));

			runInAction('Update with fetched stats', () => {
				this.stats = stats;
			});
		} catch (err) {

			console.log('[ERROR StatsStore.fetchStats]', err);
		} finally {

			this.isLoading = false;
		}
	}

	@action.bound
	onNewData (stats) {
		this.stats = stats;
		this.isLoading = false;
	}

	/**
	 * Fetch the trailing N-day analytics roll-up for an artist.
	 * Backed by GET /api/artists/daily-stats/:id (artist owner or admin only).
	 * Response shape: { artistID, windowDays, fromDay, toDay, days: [...], totals: {...} }
	 */
	@action
	async fetchDailyStats (artistID, days = 30) {
		this.isLoadingDaily = true;

		try {
			const route = `${config.routes.artistDailyStats.replace(/\:id/, artistID)}?days=${days}`;
			const data = await apiStore.fetch({ route });

			runInAction('Update daily stats', () => {
				this._dailyStats = data || null;
			});
		} catch (err) {

			console.log('[ERROR StatsStore.fetchDailyStats]', err);
			runInAction('Clear daily stats on error', () => {
				this._dailyStats = null;
			});
		} finally {

			runInAction('Done loading daily', () => {
				this.isLoadingDaily = false;
			});
		}
	}
}

const statsStore = new StatsStore();
export default statsStore;
